import React from 'react'
import Layout from '../../Layout'
import AcceptedOrderDeliveryPeykContainer from '../../../../Components/OrdersPeykPart/AcceptedOrderDeliveryPeykContainer/AcceptedOrderDeliveryPeykContainer'

const AcceptedOrderDeliveryPeyk = () => {
  return (
    <Layout>
      <AcceptedOrderDeliveryPeykContainer/>
    </Layout>
  )
}

export default AcceptedOrderDeliveryPeyk